const AREAS = ["Etobicoke", "Mississauga", "Vaughan", "Brampton", "Toronto"];

export default function AreaMarquee() {
  const row = [...AREAS, ...AREAS];
  return (
    <div data-testid="area-marquee" className="marquee border-y border-white/10 bg-[#0A0A0A] py-6" aria-label="Service areas">
      <div className="marquee-track">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center gap-16" aria-hidden={half === 1}>
            {row.map((area, i) => (
              <span key={`${half}-${i}`} className="flex items-center gap-16">
                <span className="font-display text-6xl text-outline uppercase">{area}</span>
                <span className="text-[#F59E0B] text-2xl">&#9670;</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
